<template>
  <div>
    <base-card>
      <div>
        <v-card-title v-if="!cardLoading" class="mb-n7">
          <v-row>
            <v-col class="d-flex justify-space-between flex-wrap align-center">
              <div>
                <v-btn
                  class="ma-2 mb-6"
                  small
                  dark
                  color="primary"
                  @click="(title = 'Add'), openDialog()"
                >
                  <v-icon small>mdi-plus</v-icon>
                  Add Ingredient
                </v-btn>
                <v-btn
                  class="ma-2 mb-6"
                  small
                  dark
                  :loading="multiBtnLoading"
                  color="danger"
                  v-if="selected != ''"
                  @click="dialogDelete = true"
                >
                  <v-icon small>mdi-delete</v-icon>
                  delete
                </v-btn>
              </div>

              <!-- <div style="width: 250px">
                <v-select
                  v-model="selectBranch"
                  :items="branchList"
                  item-text="name"
                  item-value="branch_id"
                  solo
                  dense
                ></v-select>
              </div> -->
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-title>
          <v-row>
            <v-col cols="12" lg="8">Ingredient</v-col>
            <v-col cols="12" lg="4"
              ><v-text-field
                class="mt-n5"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                v-if="!cardLoading"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-card-title>
        <div class="text-center" v-if="cardLoading">
          <v-progress-circular
            class="mb-16"
            :size="40"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <div v-show="!cardLoading">
          <v-data-table
            v-model="selected"
            :search="search"
            :headers="headers"
            :items="ingredientList"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            item-key="ingredient_company_id"
            @click:row="handleClick"
            show-select
          >
          </v-data-table>
        </div>
      </div>
    </base-card>

    <v-dialog v-model="dialog" width="600">
      <base-card>
        <v-card-text>
          <div class="mb-5">
            <span class="text-h6">{{ title }} Ingredient </span>
          </div>
          <v-text-field
            prepend-icon="mdi-alphabetical-variant"
            label="Ingredient Name"
            v-model="iName"
            :error-messages="iNameErrors"
            required
            @input="$v.iName.$touch()"
            @blur="$v.iName.$touch()"
          ></v-text-field>

          <v-textarea
            counter
            label="Ingredient Description"
            v-model="iDescription"
            prepend-icon="mdi-comment"
            rows="3"
            :error-messages="iDescriptionErrors"
            @input="$v.iDescription.$touch()"
            @blur="$v.iDescription.$touch()"
          ></v-textarea>

          <v-select
            solo
            v-model="selectUnit"
            :items="unitList"
            label="Unit"
          ></v-select>
          <VueFileAgent
            ref="vueFileAgent"
            :theme="'grid'"
            :multiple="false"
            :deletable="true"
            :meta="true"
            :accept="'image/*'"
            :maxSize="'80KB'"
            :maxFiles="1"
            :helpText="'Choose Image or drag & drop here'"
            :errorText="{
              type: 'Invalid file type. Only images Allowed',
              size: 'Files should not exceed 80KB in size',
            }"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event)"
            @delete="fileDeleted($event)"
            v-model="fileRecords"
          ></VueFileAgent>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            :loading="singleBtnLoading"
            v-if="title == 'Edit'"
            @click="dialogDelete = true"
            text
            icon
            color="red lighten-2"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="dialogAction()"
            :loading="saveBtnLoading"
            text
          >
            save
          </v-btn>
        </v-card-actions>
      </base-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-subtitle-1"
          >Are you sure to delete this ingredient? Branch ingredient and
          ingredient movement will be delete.</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" @click="deleteIngredient" text>OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { BASEURL, BASESYNCURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    iName: { required },
    iDescription: { maxLength: maxLength(200) },
  },
  data() {
    return {
      domain: BASEURL,
      syncDomain: BASESYNCURL,
      branchList: [],
      snackbar: false,
      text: "",
      snackbarColor: "",
      timeout: 1900,
      companyID: "",
      headers: [
        { text: "Name", value: "name" },
        {
          text: "Unit",
          sortable: true,
          value: "unit",
        },
        { text: "description", value: "description" },
      ],
      ingredientList: [],
      iDescription: "",
      unitList: ["each", "kg", "g", "l", "ml"],
      selectUnit: "each",
      fileRecords: [],
      fileRecordsForUpload: [],
      errorFound: 0,
      imageName: "",
      newImageName: "",
      ingredientCompanyID: "",
      saveBtnLoading: false,
      singleBtnLoading: false,
      multiBtnLoading: false,
      dialog: false,
      title: "",
      iName: "",
      selectBranch: "",
      cardLoading: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialogDelete: false,
      search: "",
      selected: [],
    };
  },

  watch: {
    fileRecords() {
      for (let i = 0; i < this.fileRecords.length; i++) {
        if (
          this.fileRecords[i].error.size == true ||
          this.fileRecords[i].error.type == true
        ) {
          this.errorFound++;
        }
      }
    },
  },

  computed: {
    iNameErrors() {
      const errors = [];
      if (!this.$v.iName.$dirty) return errors;
      !this.$v.iName.required && errors.push("Customer name is required");
      return errors;
    },
    iDescriptionErrors() {
      const errors = [];
      if (!this.$v.iDescription.$dirty) return errors;
      !this.$v.iDescription.maxLength &&
        errors.push("Must less than 200 characters");
      return errors;
    },
  },

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getAllIngredient();
    this.getCompanyBranch();
  },

  methods: {
    getAllIngredient() {
      const params = new URLSearchParams();
      params.append("getAllIngredient", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.ingredientList = response.data.ingredient;
            this.cardLoading = false;
          } else {
            this.ingredientList = [];
            this.cardLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    openDialog() {
      if (this.title == "Add") {
        this.$v.$reset();
        this.iName = "";
        this.iDescription = "";
        this.selectUnit = "each";
        this.fileRecords = [];
        this.fileRecordsForUpload = [];
        this.dialog = true;
      } else {
        this.$v.$reset();
        this.dialog = true;
      }
    },

    // for image
    getImageSizeInBytes(imgURL) {
      var request = new XMLHttpRequest();
      request.open("HEAD", imgURL, false);
      request.send(null);
      var headerText = request.getAllResponseHeaders();
      var re = /Content\-Length\s*:\s*(\d+)/i;
      re.exec(headerText);
      return parseInt(RegExp.$1);
    },

    getImageBanner(imgName) {
      var tempObj = {};
      const imgExtension = imgName.split(".");
      tempObj.name = imgName;
      tempObj.url =
        this.domain + "ingredient_pic/" + this.companyID + "/" + imgName;
      const size = this.getImageSizeInBytes(
        this.domain + "ingredient_pic/" + this.companyID + "/" + imgName
      );
      tempObj.size = size;
      tempObj.error = {};
      tempObj.raw = "";
      tempObj.filename = imgName;
      tempObj.error.size = false;
      tempObj.error.type = false;
      tempObj.type = "image/" + imgExtension[1];
      this.fileRecords.push(tempObj);
      this.fileRecordsForUpload.push(tempObj);
    },

    handleClick(item) {
      this.fileRecords = [];
      this.fileRecordsForUpload = [];
      this.ingredientCompanyID = item.ingredient_company_id;
      this.newImageName = "";
      this.iName = item.name;
      this.iDescription = item.description;
      this.selectUnit = item.unit;
      this.imageName = item.image;
      if (item.image != "") {
        this.getImageBanner(item.image);
        this.newImageName = this.fileRecords[0].filename;
      }
      this.title = "Edit";
      this.openDialog();
    },

    deleteIngredient() {
      if (this.selected != "") {
        this.multiBtnLoading = true;
        const array = [];
        for (let i = 0; i < this.selected.length; i++) {
          array.push(this.selected[i].ingredient_company_id);
        }
        const params = new URLSearchParams();
        params.append("deleteMultiIngredient", "done");
        params.append("array_ingredient_company_id", JSON.stringify(array));
        params.append("company_id", this.companyID);
        axios({
          method: "post",
          url: this.domain + "/ingredient/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.dialog = false;
              this.multiBtnLoading = false;
              this.text = "Successfully delete";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.selected = [];
              this.dialogDelete = false;
              this.getAllIngredient();
              this.sendNotication();
            } else {
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.singleBtnLoading = true;
        const params = new URLSearchParams();
        params.append("deleteIngredient", "done");
        params.append("ingredient_company_id", this.ingredientCompanyID);
        params.append("company_id", this.companyID);

        axios({
          method: "post",
          url: this.domain + "/ingredient/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.singleBtnLoading = false;
              this.dialog = false;
              this.text = "Successfully delete";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.dialogDelete = false;
              this.getAllIngredient();
              this.sendNotication();
            } else {
              this.singleBtnLoading = false;
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchList = response.data.branch;
            this.selectBranch = this.branchList[0].branch_id;

          } else {
            console.log("no list get");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    isBlob(input) {
      if ("Blob" in window && input instanceof Blob) return true;
      else return false;
    },

    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);

      for (let i = 0; i < this.fileRecordsForUpload.length; i++) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.fileRecordsForUpload[i].raw = reader.result;
          this.fileRecordsForUpload[i].filename = "";
        };
        if (this.isBlob(this.fileRecordsForUpload[i].file)) {
          reader.readAsDataURL(this.fileRecordsForUpload[i].file);
        } else {
          this.fileRecordsForUpload[i].raw = "";
        }
      }

      this.newImageName = this.fileRecordsForUpload[0].file.name;
    },

    onBeforeDelete: function (fileRecord) {
      this.errorFound = 0;
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        if (confirm("Are you sure you want to delete?")) {
          // queued file, not yet uploaded. Just remove from the arrays
          this.fileRecordsForUpload.splice(i, 1);
          var k = this.fileRecords.indexOf(fileRecord);
          if (k !== -1) this.fileRecords.splice(k, 1);
          this.newImageName = "";
        }
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },

    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      }
    },

    sendNotication() {
      for (let i = 0; i < this.branchList.length; i++) {
        const params = new URLSearchParams();
        params.append("send_notification", "done");
        params.append("branch_id", this.branchList[i].branch_id);
        params.append("type", "1");

        axios({
          method: "post",
          url: this.syncDomain + "/sync/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              console.log("Send Notification successfully");
            } else {
              console.log("Send Notification fail");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    dialogAction() {
      if (this.title == "Add") {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.saveBtnLoading = true;
          const params = new URLSearchParams();
          params.append("addIngredient", "done");
          params.append("company_id", this.companyID);
          params.append("iName", this.iName);
          params.append("iDescription", this.iDescription);
          params.append("selectUnit", this.selectUnit);
          params.append(
            "image_file",
            JSON.stringify(this.fileRecordsForUpload)
          );

          axios({
            method: "post",
            url: this.domain + "/ingredient/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.dialog = false;
                this.text = "Successfully add";
                this.snackbar = true;
                this.snackbarColor = "success";
                this.saveBtnLoading = false;
                this.getAllIngredient();
                this.sendNotication();
              } else {
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
                this.saveBtnLoading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.saveBtnLoading = true;
          const params = new URLSearchParams();
          params.append("editIngredient", "done");
          params.append("ingredient_company_id", this.ingredientCompanyID);
          params.append("company_id", this.companyID);
          params.append("iName", this.iName);
          params.append("iDescription", this.iDescription);
          params.append("selectUnit", this.selectUnit);
          params.append(
            "image_file",
            JSON.stringify(this.fileRecordsForUpload)
          );
          params.append("oldImage", this.imageName);
          params.append("newImage", this.newImageName);

          axios({
            method: "post",
            url: this.domain + "/ingredient/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.dialog = false;
                this.text = "Successfully edit";
                this.snackbar = true;
                this.snackbarColor = "success";
                this.saveBtnLoading = false;
                this.getAllIngredient();
                this.sendNotication();
              } else {
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
                this.saveBtnLoading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>